/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */
/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/gpu-exercise/v0.ts
 */

import { createValidator } from '../../helpers/validator';
export const GpuExerciseV0Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    assignment: {
      type: 'string'
    },
    title: {
      type: 'string'
    },
    sample_code: {
      type: 'string',
      default: ''
    },
    instructions: {
      type: ['string', 'null'],
      default: null
    },
    sct: {
      type: 'string',
      default: ''
    },
    pre_exercise_code: {
      type: 'string',
      default: ''
    },
    solution: {
      type: 'string',
      default: ''
    },
    hint: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    }
  },
  required: ['assignment', 'title', 'sample_code', 'instructions', 'sct', 'pre_exercise_code', 'solution', 'hint', 'xp', 'chapter_id', 'course_id'],
  definitions: {}
};
export const isValidGpuExerciseV0 = createValidator(GpuExerciseV0Schema);
export const GpuExerciseV0Definition = {
  schema: GpuExerciseV0Schema,
  validate: isValidGpuExerciseV0
};